export default {
  "common.save": "保存",
  "common.cancel": "キャンセル",
  "common.delete": "削除",
  "common.edit": "編集",
  "common.add": "追加",
  "common.back": "戻る",
  "common.loading": "読み込み中...",
  "common.error": "エラーが発生しました",
  "common.success": "成功",
  "common.confirm": "確認",
  "common.search": "検索",
  "common.filter": "フィルター",
  "common.all": "すべて",
  "common.comingSoon": "近日公開",
  "common.noResults": "結果なし",
  "common.retry": "再試行",

  "auth.login": "ログイン",
  "auth.signup": "新規登録",
  "auth.logout": "ログアウト",
  "auth.email": "メールアドレス",
  "auth.password": "パスワード",
  "auth.name": "氏名",
  "auth.confirmPassword": "パスワードの確認",
  "auth.forgotPassword": "パスワードをお忘れですか？",
  "auth.noAccount": "アカウントをお持ちでないですか？",
  "auth.haveAccount": "すでにアカウントをお持ちですか？",
  "auth.agreeTerms": "利用規約とプライバシーポリシーに同意します",

  "nav.home": "ホーム",
  "nav.payments": "支払い",
  "nav.add": "追加",
  "nav.analytics": "分析",
  "nav.profile": "プロフィール",
  "nav.allPayments": "すべての支払い",
  "nav.addPayment": "支払いを追加",
  "nav.subscriptions": "サブスクリプション",
  "nav.calendar": "カレンダー",
  "nav.documents": "ドキュメント",
  "nav.settings": "設定",
  "nav.personalInfo": "個人情報",
  "nav.changePassword": "パスワード変更",
  "nav.twoFactor": "二段階認証",
  "nav.devices": "デバイス",
  "nav.reminders": "リマインダー",
  "nav.editPayment": "支払いを編集",
  "nav.paymentDetail": "支払い詳細",

  "dashboard.title": "ダッシュボード",
  "dashboard.greeting": "おはようございます",
  "dashboard.totalDue": "合計支払額",
  "dashboard.thisMonth": "今月",
  "dashboard.upcomingPayments": "今後の支払い",
  "dashboard.quickStats": "クイック統計",
  "dashboard.noUpcoming": "今後の支払いなし",
  "dashboard.addFirst": "最初の支払いを追加して始めましょう",
  "dashboard.budgetUsed": "使用済み予算",

  "payments.title": "支払い",
  "payments.add": "支払いを追加",
  "payments.edit": "支払いを編集",
  "payments.detail": "支払い詳細",
  "payments.amount": "金額",
  "payments.dueDate": "支払期日",
  "payments.category": "カテゴリ",
  "payments.frequency": "頻度",
  "payments.notes": "メモ",
  "payments.status.paid": "支払済み",
  "payments.status.pending": "保留中",
  "payments.status.overdue": "期限超過",
  "payments.markAsPaid": "支払済みにする",
  "payments.deleteConfirm": "この支払いを削除しますか？",
  "payments.frequency.once": "一回",
  "payments.frequency.weekly": "毎週",
  "payments.frequency.monthly": "毎月",
  "payments.frequency.yearly": "毎年",
  "payments.noPayments": "支払いはまだありません",

  "subscriptions.title": "サブスクリプション",
  "subscriptions.add": "サブスクリプションを追加",
  "subscriptions.monthly": "月間支出",
  "subscriptions.active": "アクティブ",
  "subscriptions.paused": "一時停止",
  "subscriptions.overdue": "期限超過",
  "subscriptions.nextBilling": "次回請求日",
  "subscriptions.billingCycle": "請求サイクル",

  "analytics.title": "分析",
  "analytics.spendingByCategory": "カテゴリ別支出",
  "analytics.monthlyTrend": "月別トレンド",
  "analytics.totalSpent": "合計支出",
  "analytics.paidThisMonth": "今月の支払い",
  "analytics.pending": "保留中",
  "analytics.noData": "この期間のデータなし",

  "calendar.title": "カレンダー",
  "calendar.noPaymentsToday": "この日付に支払いなし",
  "calendar.connectGoogle": "Googleカレンダーに接続",
  "calendar.export": "カレンダーをエクスポート (.ics)",
  "calendar.openGoogle": "Googleカレンダーを開く",
  "calendar.sync": "カレンダー同期",

  "documents.title": "ドキュメント",
  "documents.upload": "ドキュメントをアップロード",
  "documents.noDocuments": "ドキュメントなし",
  "documents.maxSize": "最大10MB — PDF、JPEG、PNG",

  "profile.title": "プロフィール",
  "profile.settings": "設定",
  "profile.reminders": "リマインダー",
  "profile.personalInfo": "個人情報",
  "profile.changePassword": "パスワード変更",
  "profile.twoFactor": "二段階認証",
  "profile.devices": "デバイス",
  "profile.language": "言語",
  "profile.currency": "通貨",
  "profile.deleteAccount": "アカウント削除",
  "profile.plan.free": "無料プラン",
  "profile.plan.pro": "Proプラン",
  "profile.upgradeToPro": "Proにアップグレード",
  "profile.connectedDevices": "接続済みデバイス",
  "profile.pendingTill": "日付まで保留",

  "reminders.title": "リマインダー設定",
  "reminders.daysBefore": "前もって通知",
  "reminders.email": "メール通知",
  "reminders.push": "プッシュ通知",
  "reminders.sms": "SMS通知",

  "upgrade.title": "Proにアップグレード",
  "upgrade.subtitle": "すべての機能を解除",
  "upgrade.perMonth": "/月",
  "upgrade.upgrade": "今すぐアップグレード",

  "notifications.title": "通知",
  "notifications.none": "新しい通知なし",
  "notifications.viewAll": "すべての支払いを表示",
  "notifications.overdue": "が期限超過です",
  "notifications.dueToday": "が本日期限です",
  "notifications.dueSoon": "であと",
  "notifications.days": "日後に期限",

  "error.required": "このフィールドは必須です",
  "error.invalidEmail": "無効なメールアドレス",
  "error.passwordTooShort": "パスワードは6文字以上必要です",
  "error.passwordMismatch": "パスワードが一致しません",
  "error.networkError": "ネットワークエラー。接続を確認してください。",
  "error.unauthorized": "セッションが期限切れです。再ログインしてください。",
  "error.notFound": "ページが見つかりません",

  "settings.language": "言語",
  "settings.selectLanguage": "言語を選択",
  "settings.selectCurrency": "通貨を選択",
};
